import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { getModalState } from '../../../../app-state/modals'
import { closeDialog } from '../../../../app-state/modals/state.dialog'
import { updateRoomState } from '../../../../app-state/state.rooms'
import { FloaterSize, SettingsType } from '../../../../constants/enums'
import i18n from '../../../../utilities/i18n'
import Button from '../../../Buttons/Button'
import { useSettingSelector } from '../../../Hooks/useSettings'
import { getThemeSpacing } from '../../../styles/appTheme'
import { maxWindowWidth } from '../../../styles/breakpoints'

const StyledRoot = styled('div')({
    padding: getThemeSpacing(2),
    fontSize: '13px',
    '& span': {
        textAlign: 'center',
    },
})

const buttonContainer = css({
    textAlign: 'center',
})

const buttonStyles = css({
    margin: getThemeSpacing(),
    padding: `${getThemeSpacing(0.75)} ${getThemeSpacing(2)}`,
    [maxWindowWidth(360)]: {
        fontSize: 11,
    },
})

const HideFloatingPlayer = () => {
    const [, saveFloatingPreviewSettings] = useSettingSelector(
        SettingsType.DEFAULT,
        'enableFloatingPreview',
    )

    const confirmHide = () => {
        const floatingRoom = getModalState().floating_room
        if (floatingRoom.show && floatingRoom.size < FloaterSize.Fullscreen) {
            updateRoomState(floatingRoom.id, {
                viewing: false,
            })
        }
        saveFloatingPreviewSettings(false)
        closeDialog()
    }

    const cancelHide = () => {
        closeDialog()
    }

    return (
        <StyledRoot data-testid="Container__HideFloatingPlayerDialog">
            <div>{i18n.t('settings.extraOptions.dialogText')}</div>
            <br />
            <div css={buttonContainer}>
                <Button
                    onClick={cancelHide}
                    data-testid="Button__Cancel"
                    css={buttonStyles}
                    size="medium"
                    cancel
                >
                    Cancel
                </Button>
                <Button
                    onClick={confirmHide}
                    data-testid="Button__Confirm"
                    css={buttonStyles}
                    size="medium"
                >
                    Confirm
                </Button>
            </div>
        </StyledRoot>
    )
}

export default HideFloatingPlayer
